/**
 * Fime – Global Presence Map: lazy-load + marker pulse animation
 *
 * The map SVG (~2790 merged texture dots + 26 animated markers) is a
 * large payload (~490KB uncompressed). Rather than inlining it in the
 * initial server-rendered HTML — where it would always be downloaded
 * and parsed on every page load regardless of whether the visitor
 * ever scrolls that far — it's kept as a separate static asset and
 * only fetched via IntersectionObserver once the section is about to
 * enter the viewport.
 *
 * rootMargin gives a 300px head start so the fetch/inject completes
 * before the user actually scrolls into view (no visible pop-in).
 */

const PULSE_DURATION = 2.6;

function startMarkerPulses(container) {
	const pulseCircles = container.querySelectorAll('circle[fill="#7B3FD4"][r="4.875"]');

	pulseCircles.forEach(function (circle) {
		const randomDelay = Math.random() * PULSE_DURATION;
		circle.style.animationDelay = '-' + randomDelay + 's';
	});
}

const mapContainer = document.querySelector('.global-presence-map[data-map-src]');

if (mapContainer && 'IntersectionObserver' in window) {
	const observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;

				observer.unobserve(entry.target);

				const src = entry.target.getAttribute('data-map-src');

				fetch(src)
					.then(function (response) {
						return response.text();
					})
					.then(function (svgMarkup) {
						entry.target.innerHTML = svgMarkup;
						startMarkerPulses(entry.target);
					})
					.catch(function (error) {
						console.error('Failed to load global presence map SVG:', error);
					});
			});
		},
		{ rootMargin: '300px' }
	);

	observer.observe(mapContainer);
} else if (mapContainer) {
	const src = mapContainer.getAttribute('data-map-src');
	fetch(src)
		.then(function (response) {
			return response.text();
		})
		.then(function (svgMarkup) {
			mapContainer.innerHTML = svgMarkup;
			startMarkerPulses(mapContainer);
		});
}
